import React, { ComponentProps } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

type Props = React.PropsWithoutRef<ComponentProps<typeof Button>> & {
  tooltip?: string;
  tooltipProps: ComponentProps<typeof Tooltip>;
  children: any;
};
// Button with Tooltip
const TooltipButton = ({ tooltip, tooltipProps, children, ...props }: Props) => {
  const renderTooltip = props => (
    <Tooltip id="button-tooltip" {...props}>
      {tooltip}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="right"
      delay={{ hide: 450, show: 300 }}
      // overlay={tooltipProps => (
      //   <Tooltip id="button-tooltip" {...props}>
      //     {tooltip}
      //   </Tooltip>
      // )}
      overlay={renderTooltip}
    >
      <Button {...props}>{children}</Button>
    </OverlayTrigger>
  );
};

export default React.memo(TooltipButton);

